<template>
  <div class="app-container">
    <!-- Global Loading Overlay -->
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center loader-wrapper">
      <div>
        <img src="/img/preloader_img.png" class="w-50 d-block mx-auto" alt="" />
      </div>
    </div>

    <!-- Main Content -->
    <div class="mobile-viewport shadow-lg">
      <router-view v-slot="{ Component, route }">
        <transition :name="route.meta.transition || 'fade'">
          <div :key="route.name">
            <Component :is="Component"></Component>
          </div>
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isLoading() {
      return this.$store.getters.isLoading
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
@import './assets/css/variables.css';
@import '~bootstrap/dist/css/bootstrap.min.css';
@import '~bootstrap-icons/font/bootstrap-icons.css';
@import './assets/css/global.css';
@import './assets/css/components.css';
</style>
